import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f14f78e")

_pushScopeId("data-v-5f14f78e")
const _hoisted_1 = { class: "main-header" }
const _hoisted_2 = { class: "container main-header__container" }
const _hoisted_3 = { class: "main-header__control" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MainLogo = _resolveComponent("MainLogo")
  const _component_NavMenu = _resolveComponent("NavMenu")
  const _component_SwitchLanguage = _resolveComponent("SwitchLanguage")
  const _component_NavMobileMenu = _resolveComponent("NavMobileMenu")
  const _component_ProfileMenu = _resolveComponent("ProfileMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MainLogo),
      _createVNode(_component_NavMenu, { class: "main-header__nav-menu" }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_SwitchLanguage),
        _createVNode(_component_NavMobileMenu, { class: "main-header__nav-mobile-menu" }),
        _createVNode(_component_ProfileMenu, { class: "main-header__profile-menu" })
      ])
    ])
  ]))
})